<template>
    <div class="animated fade-in">
        <h1 class="display-4 font-weight-lighter">My Estimates</h1>
        <div class="mb-4"></div>
        <customer-estimate-table></customer-estimate-table>
    </div>
</template>

<script>
import CustomerEstimateTable from '@/components/estimates/CustomerEstimateTable.vue'
    export default {
      name: 'CustomerEstimateIndex',
      components: {CustomerEstimateTable}
	}
</script>
